<!--div class="search-loader" *ngIf="showLoader">
<img src="/assets/css/images/platform/loader.gif" />
</div-->

@if (showLoader) {
  <div class="search-loader">
    <sem-loader [showLoader]="true"></sem-loader>
  </div>
}



<div class="inner-item-wrapper">
  @if (repositoryName !== 'semantic') {
    <div class="item-container wg-search">
      <div class="search-control">
        <div class="wrapper" [ngClass]="{'wrapper-without-datatools' : !showDataTools() }">
          <div class="wg-search-input-group">
            <span class="material-symbols-outlined wg-search-input-icon">search</span>
            <div class="search-input">
              <input type="text" [(ngModel)]="mainSearchValue" (keydown.enter)="onKeydown($event)" class="search-input" placeholder="{{translate(getSearchPlaceHolder())}}">
            </div>
            @if (showSearchWhere()) {
              <div class="search-selector selec">
                <div class="dd-search search-dd">
                  @if (globalSearch) {
                    <mat-form-field appearance="fill" class="search-bar-multipleselect">
                      <mat-select placeholder="{{translate('galis_js_SearchForm_SearchEverywhere')}}" [formControl]="searchClassTypes" multiple class="search-bar-multipleselect-select">
                        @for (searchClassType of searchClassTypesList; track searchClassType) {
                          <mat-option class="search-bar-multipleselect-option" [value]="searchClassType.FullName"
                          (onSelectionChange)="searchInChange($event)">{{searchClassType.Translation}}</mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  }
                  @if (!globalSearch) {
                    <p>{{translate('galis_js_SearchForm_SearchEverywhere')}}</p>
                  }
                </div>
              </div>
            }
          </div>
          <div class="search-button" (click)="onKeydown($event)">
            <p>{{translate('galis_js_SearchForm_SearchLabel')}}</p>
          </div>
          <div class="wg-search-separator"></div>
          <div class="search-button-query-builder" (click)="openQueryBuilderDialog()">
            <span class="material-symbols-outlined">tune</span>
            <p>{{translate('galis_js_SearchForm_SearchLabelQueryBuilder')}}</p>
          </div>
        </div>
        <div class="search-items">
          @for (item of model?.AdditionalSearchFields; track item; let index = $index) {
            <div class="search-item" [ngClass]="{'multiple-field-search-item': item.IsMultipleFieldControl}">
              <sem-dynamic-search-field [name]="item.Name" (keydown.enter)="onKeydown($event)" [model]="model" [label]="item.Translation" [modelIndex]="index" [controlName]="item.FormControlName" [isRangeField]="item.IsRangeField"
              [isCheckBox]="item.IsCheckBox" [settings]="item.Settings" [fullType]="item.FullType" [isMultipleFieldControl]="item.IsMultipleFieldControl" [isDropDown]="item.IsDropdown" [dropdownPreFilter]="item.DropdownAttributeFilterQuery" [dropdownType]="item.DropdownFullTypeOfSimpleProperty" [rangeType]="item.RangeType"
              style="display: block; width: 100%;"></sem-dynamic-search-field>
            </div>
          }
        </div>
        @if (showDataTools() && hideButtons == 'False' && currentEnviromentSettings?.useOldSearchViewFeature == false && !isRestrictedByGroup('hideAddFieldForGroups')) {
          <div class="wg-quick-add-field">
            <div class="wg-quick-add-anchor" #quickAddContainer>
            <button type="button" class="wg-quick-add-btn" (click)="toggleQuickAddDropdown($event)">
              <span class="material-symbols-outlined">add</span>
              Dodaj polje
            </button>
            @if (showQuickAddDropdown) {
              <div class="wg-quick-add-panel" (click)="$event.stopPropagation()">
                <div class="wg-quick-add-search-wrapper">
                  <div class="wg-quick-add-search">
                    <span class="material-symbols-outlined">search</span>
                    <input type="text" placeholder="Iskanje polj..."
                      [(ngModel)]="quickAddSearchValue"
                      (input)="filterQuickAddFields()" />
                  </div>
                </div>
                <div class="wg-quick-add-list">
                  @for (field of filteredQuickAddFields; track field) {
                    <button type="button" class="wg-quick-add-item" [title]="field.Translation" (click)="toggleField(field)">
                      <div class="wg-quick-add-checkbox" [class.wg-quick-add-checked]="isFieldActive(field)">
                        @if (isFieldActive(field)) {
                          <span class="material-symbols-outlined">check</span>
                        }
                      </div>
                      <span>{{ field.Translation }}</span>
                    </button>
                  }
                  @if (filteredQuickAddFields.length === 0) {
                    <div class="wg-quick-add-empty">Ni rezultatov</div>
                  }
                </div>
                <div class="wg-quick-add-footer">
                  <button type="button" class="wg-quick-add-footer-btn" (click)="resetFieldsToDefault()">Ponastavi</button>
                  <div>
                    @if (quickAddDirty) {
                      <button type="button" class="wg-quick-add-footer-btn wg-quick-add-footer-save" (click)="saveQuickAddFields()">Shrani</button>
                    }
                    <button type="button" class="wg-quick-add-footer-btn wg-quick-add-footer-close" (click)="showQuickAddDropdown = false">Zapri</button>
                  </div>
                </div>
              </div>
            }
            </div>
          </div>
        }
        @if (showDataTools()) {
          <div class="wg-search-actions">
            <div class="wg-search-actions-left">
              @if (hideButtons == 'False' && currentEnviromentSettings?.useOldSearchViewFeature == false && !isRestrictedByGroup('hideNewViewForGroups')) {
                <div class="wg-search-action-btn" (click)="openViewSettings(true)">
                  <span class="material-symbols-outlined">add</span>
                  <span>{{translate('galis_js_SearchForm_CreateNewView')}}</span>
                </div>
              }
              @if (hideButtons == 'False' && userSearchSettings?.CanEditView && currentEnviromentSettings?.useOldSearchViewFeature == false && !isRestrictedByGroup('hideViewSettingsForGroups')) {
                <div class="wg-search-action-btn" (click)="openViewSettings(false)">
                  <span class="material-symbols-outlined">settings</span>
                  <span>{{translate('galis_js_SearchForm_OpenViewSettings')}}</span>
                </div>
              }
              @if (hideButtons == 'False' && currentEnviromentSettings?.useOldSearchViewFeature == true) {
                <div class="wg-search-action-btn" (click)="modifySearchFields()">
                  <span class="material-symbols-outlined">tune</span>
                  <span>{{translate('galis_js_SearchForm_ModifySettings')}}</span>
                </div>
              }
            </div>
            <div class="wg-search-actions-right">
              @if (hideButtons == 'False') {
                <div class="wg-search-action-btn wg-search-action-clear" (click)="clearSearchFieldValues()">
                  <span class="material-symbols-outlined">close</span>
                  <span>{{translate('galis_js_SearchForm_ClearSearchFieldValues')}}</span>
                </div>
              }
            </div>
          </div>
        }
      </div>
    </div>
  }

  @if (repositoryName == 'semantic') {
    <div class="item-container">
      <div class="search-control search-control-semantic">
        <div class="wrapper">
          <div class="search-input">
            <input type="text" [(ngModel)]="mainSearchValue" (keydown.enter)="onKeydown($event)" class="search-input" placeholder="{{translate(getSearchPlaceHolder())}}">
          </div>
          <!--<p class="semantic-search-label">Odgovor iskanja:</p>
          <div class="search-items-semantic-wrapper">
            <div class="search-items-semantic-response-text">
              {{semanticSearchResponsetext}}
            </div>
          </div>-->
        </div>
      </div>
    </div>
  }
</div>

